import React from "react";
import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "Prise de contact",
    desc: "Échange téléphonique ou formulaire en ligne pour comprendre vos besoins et votre activité.",
  },
  {
    num: "02",
    title: "Visite & audit",
    desc: "Visite gratuite de vos locaux pour évaluer les surfaces, fréquences et contraintes spécifiques.",
  },
  {
    num: "03",
    title: "Devis sur mesure",
    desc: "Proposition claire et détaillée sous 48h, sans engagement et parfaitement adaptée à votre budget.",
  },
  {
    num: "04",
    title: "Intervention",
    desc: "Mise en place de l'équipe dédiée, du matériel et des produits conformes aux normes d'hygiène.",
  },
  {
    num: "05",
    title: "Suivi qualité",
    desc: "Contrôles réguliers, cahier de liaison digital et interlocuteur unique pour une satisfaction continue.",
  },
];

export default function Process() {
  return (
    <section id="process" className="relative py-24 md:py-32 bg-white" data-testid="process-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.3em] text-[#2E9E6E] font-medium mb-4">
            — Notre processus
          </div>
          <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl text-[#0F2B5B] leading-[1.02] tracking-tight">
            Cinq étapes simples, zéro surprise.
          </h2>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-slate-200" />
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-6">
            {STEPS.map((step, i) => (
              <motion.div
                key={step.num}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative"
                data-testid={`process-step-${i + 1}`}
              >
                <div className="relative lg:pt-0">
                  <div className="hidden lg:block absolute -top-1 left-0 w-3 h-3 bg-[#2E9E6E]" />
                  <div className="font-display text-5xl md:text-6xl font-semibold text-slate-200 leading-none lg:mt-6">
                    {step.num}
                  </div>
                  <h3 className="mt-4 font-display text-xl font-semibold text-[#0F2B5B] leading-tight">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
